export const refreshReducer = (state, action) => {
  switch (action.type) {
    case "refresh_found":
      return {
        ...state,
        [action.modelId]: {
          isRefreshing: true,
          toastId: action.toastId,
        },
      };

    case "refresh_complete":
      return {
        ...state,
        [action.modelId]: {
          isRefreshing: false,
          toastId: null,
        },
      };

    default:
      return state;
  }
};
